// src/components/Toast.jsx
import { useEffect, useState } from "react";

export default function Toast({ message, type = "success", onDone }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setVisible(false);
      setTimeout(onDone, 300);
    }, 2800);
    return () => clearTimeout(t);
  }, [onDone]);

  const colors = {
    success: { bg: "#f0fdf4", border: "#86efac", text: "#16a34a", icon: "✓" },
    error:   { bg: "#fef2f2", border: "#fca5a5", text: "#dc2626", icon: "✕" },
    info:    { bg: "#eff6ff", border: "#93c5fd", text: "#1d4ed8", icon: "ℹ" },
  };
  const c = colors[type] || colors.success;

  return (
    <div style={{
      ...styles.wrap,
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(12px)",
    }}>
      <div style={{ ...styles.toast, background: c.bg, border: `1px solid ${c.border}` }}>
        <span style={{ ...styles.icon, color: c.text }}>{c.icon}</span>
        <span style={{ ...styles.msg, color: c.text }}>{message}</span>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    position: "fixed",
    bottom: "28px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 2000,
    transition: "opacity 0.3s, transform 0.3s",
    pointerEvents: "none",
  },
  toast: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    borderRadius: "10px",
    padding: "12px 20px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
    minWidth: "240px",
    maxWidth: "420px",
    whiteSpace: "nowrap",
  },
  icon: { fontSize: "15px", fontWeight: "700", flexShrink: 0 },
  msg: { fontSize: "13px", fontWeight: "600", fontFamily: "'Pretendard','Noto Sans KR',sans-serif" },
};
